export class Currency {
  constructor (params = {}) {
    this.id = params.id ? params.id : null
    this.name = params.name ? params.name : null
    this.type = params.type ? params.type : null
    this.exchangeRate = null
  }
}
